import { ZodType, z } from 'zod';
import type { ICartPromotion } from './Cart';
import type IPromotion from './IPromotion';
import type { ILineItemPromotion } from './LineItem';
import PromotionTarget from './PromotionTarget';
import PromotionType from './PromotionType';

/** Zod schema for {@link IPromotion}. */
export const PromotionSchema = z.object({
  id: z.string(),
  campaignID: z.string(),
  name: z.string(),
  target: z.nativeEnum(PromotionTarget),
  type: z.nativeEnum(PromotionType),
  visible: z.boolean().optional(),
  label: z.string().optional(),
  couponCode: z.string().optional(),
  couponID: z.string().optional().nullable()
}) satisfies ZodType<IPromotion>;

/** Zod schema for {@link ICartPromotion}. */
export const CartPromotionSchema = PromotionSchema.extend({
  target: z.literal(PromotionTarget.Cart),
  isActive: z.boolean(),
  remainingCartValue: z.number().optional(),
  details: z.string().optional()
}) satisfies ZodType<ICartPromotion>;

/** Zod schema for {@link ILineItemPromotion}. */
export const LineItemPromotionSchema = PromotionSchema.extend({
  target: z.literal(PromotionTarget.LineItem)
}) satisfies ZodType<ILineItemPromotion>;
